import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Outlet } from "react-router-dom";

import { Box, CssBaseline, Hidden, Paper as MuiPaper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { spacing } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";

import { GlobalStyles } from "@mui/system";
import Navbar from "../components/navbar/Navbar";
import SuperAdminItems from "../components/sidebar/SuperAdminItems";
import LCOItems from "../components/sidebar/lcoItems";
import DistributorItems from "../components/sidebar/distributorItems";
import UserItems from "../components/sidebar/UserItems";
import HotelItems from "../components/sidebar/HotelItems";
import MsoItems from "../components/sidebar/MSOItems";

import Sidebar from "../components/sidebar/Sidebar";
import Footer from "../components/Footer";
import Settings from "../components/Settings";
import Notification from "../pages/components/Notification";
import useAuth from "../hooks/useAuth";
import EmployeeItems from "../components/sidebar/EmployeeItems";
import useTenant from "../hooks/useTenant";
import Logo from "../vendor/hyper_radius_logo.png";

const drawerWidth = 250;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const collapsedDrawerWidth = 70;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${(props) => (props.collapsed ? collapsedDrawerWidth : drawerWidth)}px;
    flex-shrink: 0;
    transition: width 0.2s ease-in-out;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100vw;

  ${(props) => props.theme.breakpoints.up("md")} {
    width: calc(
      100vw -
        ${(props) =>
          props.isFullscreen && props.collapsed
            ? 0
            : props.collapsed
              ? collapsedDrawerWidth
              : drawerWidth}px
    );
    transition: width 0.2s ease-in-out;
  }
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const Dashboard = ({ children }) => {
  const [logoSrc, setLogoSrc] = useState(null);
  const [logoTextName, setLogoTextName] = useState("");
  const { user, getUserMenusWithPermissions, userMenus } = useAuth();
  const { getTenant, tenant, getTenantSettings, tenantSetting, getTenantLogo, tenantLogo } =
    useTenant();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const [menuItems, setMenuItems] = useState([
    {
      title: "Pages",
      pages: [],
    },
  ]);

  console.log("content loaded for every page........");

  console.log(user, "useruser");

  const fetchData = async () => {
    await getUserMenusWithPermissions();
  };

  const fetchTenant = async (tenantId) => {
    const tenantDetails = await getTenant(tenantId);
    if (Object.keys(tenantDetails).length != 0) {
      if (tenantDetails.businessType == "MULTI_SERVICE_OPERATOR") {
        fetchTenantSettings(tenantDetails?.tenantId);
        fetchTenantLogo(tenantDetails?.tenantId);
      } else {
        fetchTenantSettings(tenantDetails?.mso?.tenantId);
        fetchTenantLogo(tenantDetails?.mso?.tenantId);
      }
    }
  };

  const fetchTenantSettings = async (tenantId) => {
    await getTenantSettings(tenantId);
  };

  const fetchTenantLogo = async (tenantId) => {
    await getTenantLogo(tenantId);
  };

  useEffect(() => {
    console.log(userMenus, "userMenususerMenususerMenus");
    if (userMenus != undefined) {
      setMenuItems([
        {
          title: "Pages",
          pages: userMenus,
        },
      ]);
    }
  }, [userMenus]);

  useEffect(() => {
    console.log(userMenus, "userMenususerMenususerMenus");
    if (user != undefined) {
      if (user.businessType != "SUPER_ADMIN") {
        fetchTenant(user.tenantId);
      } else {
        setLogoTextName("Hyper Radius");
        setLogoSrc(Logo);
      }
    }
  }, [user]);

  useEffect(() => {
    console.log(tenantLogo, "tenantLogotenantLogo");
    if (tenantLogo != null) {
      const imageUrl = URL.createObjectURL(tenantLogo);
      setLogoSrc(imageUrl);
    }
  }, [tenantLogo]);

  useEffect(() => {
    console.log(tenantSetting, "tenantSettingtenantSetting");
    if (Object.keys(tenantSetting).length != 0) {
      if (tenantSetting.logoTextName != null) {
        setLogoTextName(tenantSetting.logoTextName);
      } else {
        setLogoTextName("Hyper Radius");
      }
    }
  }, [tenantSetting]);

  const router = useLocation();

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const handleDrawerToggle = () => {
    if (isMdUp) {
      setCollapsed(!collapsed);
    } else {
      setMobileOpen(!mobileOpen);
    }
  };
  const globalStyles = (
    <GlobalStyles
      styles={{
        body: {
          height: "100%",
          overflowX: "hidden",
          background: theme.palette.background.default,
          margin: 0,
        },
        html: {
          height: "100%",
          overflowX: "hidden",
        },
        "#root": {
          height: "100%",
          overflowX: "hidden",
        },
        ".MuiIconButton-root": {
          padding: "1px",
          width: "34px",
          height: "34px",
        },
        "@media print": {
          html: {
            height: "auto !important",
            overflow: "visible !important",
          },
          body: {
            height: "auto",
            overflow: "visible",
            background: "#fff",
            "-webkit-print-color-adjust": "exact",
            "print-color-adjust": "exact",
          },
          "#root": {
            height: "auto !important",
            overflow: "visible !important",
          },

          ".MuiPaper-root, .MuiCard-root, .MuiGrid-root": {
            height: "auto !important",
            maxHeight: "none !important",
            overflow: "visible !important",
            display: "block !important",
          },
          "nav, header, footer, aside, .MuiDrawer-root, .MuiAppBar-root": {
            display: "none !important",
          },

          "#main-content": {
            display: "block !important",
            height: "auto !important",
            overflow: "visible !important",
            padding: "0 !important",
          },
          ".MuiPaper-root, .MuiCard-root, .MuiGrid-root": {
            height: "auto !important",
            maxHeight: "none !important",
            overflow: "visible !important",
            breakInside: "auto",
            pageBreakInside: "auto",
          },

          table: {
            pageBreakInside: "auto",
          },

          tr: {
            pageBreakInside: "avoid",
            breakInside: "avoid",
          },

          ".no-print": {
            display: "none !important",
          },
        },
      }}
    />
  );

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    fetchData();
    const handleFullscreenChange = () => {
      const isFull = !!document.fullscreenElement;
      setIsFullscreen(isFull);
      if (isFull) {
        setCollapsed(true);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Root>
      <CssBaseline />
      {globalStyles}
      <Notification />
      <Drawer
        theme={theme}
        collapsed={collapsed}
        sx={{
          display: isFullscreen && collapsed ? "none" : "block",
        }}
      >
        <Box sx={{ display: { xs: "block", lg: "none" } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={menuItems}
            logoSrc={logoSrc}
            logoTextName={logoTextName}
          />
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Sidebar
            collapsed={collapsed}
            PaperProps={{
              style: { width: collapsed ? collapsedDrawerWidth : drawerWidth },
            }}
            items={menuItems}
            logoSrc={logoSrc}
            logoTextName={logoTextName}
          />
        </Box>
      </Drawer>
      <AppContent
        collapsed={collapsed}
        isFullscreen={isFullscreen}
        sx={{ width: isFullscreen ? "100vw" : undefined }}
      >
        <Navbar onDrawerToggle={handleDrawerToggle} collapsed={collapsed} />
        <MainContent p={isLgUp ? 5 : 4} theme={theme} id="main-content">
          {children}
          <Outlet />
        </MainContent>
        <Footer />
      </AppContent>
      {/* <Settings /> */}
    </Root>
  );
};

export default Dashboard;
